module.exports = __webpack_public_path__ + "05_long_brown.d9e5780e.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/mom/layer5/05_long_brown.png
// module id = ebB6
// module chunks = 0